module.exports = __webpack_public_path__ + "img/advertise.48e0e786.jpeg";